import { FC } from 'react'

import { FormFieldInputProps } from '../FormFieldInput'

import * as SC from './styled'

export type FormFieldEmailProps = Omit<FormFieldInputProps, 'type'>

const FormFieldEmail: FC<FormFieldEmailProps> = ({ className, ...props }) => {
  return <SC.Input className={className} type={'email'} {...props} />
}

export default FormFieldEmail
